import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { AlertComponent } from 'ngx-bootstrap/alert/alert.component';

import { ProfileDataService } from '../../services/profile-data.service';

@Component({
    templateUrl: 'changepassword.component.html',
    standalone: false
})
export class ChangePasswordComponent {
  public model: any = {};
  public isSaving = false;

  public alerts: any[] = [];

  constructor(private router: Router, private profileDataService: ProfileDataService) {
  }

  public mudarPassword() {
    // local validations
    if (!this.model || !this.model.oldPassword ||
      this.model.oldPassword === '' || !this.model.newPassword ||
      this.model.newPassword === '' || !this.model.newPassword2 || this.model.newPassword2 === '') {

      this.alerts.push({ type: 'danger', msg: `Todos os campos são de preenchimento obrigatório`, timeout: 5000 });
      return;
    }

    if (this.model.newPassword.length < 9) {
      this.alerts.push({ type: 'warning', msg: `A nova password tem de ter um mínimo de 9 caracteres.`, timeout: 5000 });
      return;
    }

    if (this.model.newPassword !== this.model.newPassword2) {
      this.alerts.push({ type: 'danger', msg: `As passwords novas não são iguais`, timeout: 5000 });
      return;
    }
    this.isSaving = true;

    this.profileDataService
      .changePassword(this.model.oldPassword, this.model.newPassword)
      .subscribe(sucess => {
        if (sucess) {
          this.alerts.push({ type: 'success', msg: `Operação realizada com sucesso`, timeout: 5000 });
          setTimeout(() => { this.router.navigate(['/']); }, 5000);
        } else {
          this.alerts.push({ type: 'danger', msg: `Não foi possível guardar a alteração`, timeout: 5000 });
        }
        this.isSaving = false;
      },
        error => {
          this.alerts.push({ type: 'danger', msg: error, timeout: 5000 });
          this.isSaving = false;
          console.log(error);
        });
  }

  onClosed(dismissedAlert: AlertComponent): void {
    this.alerts = this.alerts.filter(alert => alert !== dismissedAlert);
  }
}
